import { urlParamKeys } from './constants';

export interface SecureAppRedirectFlags {
  isXeroPromotionEnabled?: boolean;
  isApplePayEnabled?: boolean;
  isXeroAddOnEnabled?: boolean;
  isStripeEnabled?: boolean;
  isRedirectFromSecureEnabled?: boolean;
  isStripePhase2Enabled?: boolean;
  isStripeScheduledDowngradeEnabled?: boolean;
  isHidePromoCodesEnabled?: boolean;
  isAchMicroDepositsEnabled?: boolean;
}

export function buildSecureAppSearchParams(urlParams?: string, flags?: SecureAppRedirectFlags): URLSearchParams {
  const searchParams = new URLSearchParams(urlParams);

  if (!flags || flags.isRedirectFromSecureEnabled) {
    return searchParams;
  }

  if (flags.isApplePayEnabled) {
    searchParams.set(urlParamKeys.affApplePay, 'true');
  }

  if (flags.isXeroPromotionEnabled) {
    searchParams.set(urlParamKeys.affXeroPromotion, 'true');
  }

  if (flags.isXeroAddOnEnabled) {
    searchParams.set(urlParamKeys.affXeroAddOn, 'true');
  }

  if (flags.isStripeEnabled) {
    searchParams.set(urlParamKeys.affStripe, 'true');
  }

  if (flags.isRedirectFromSecureEnabled) {
    searchParams.set(urlParamKeys.affSecureRedirect, 'true');
  }

  if (flags.isStripePhase2Enabled) {
    searchParams.set(urlParamKeys.stripePhase2, 'true');
  }

  if (flags.isStripeScheduledDowngradeEnabled) {
    searchParams.set(urlParamKeys.affStripeScheduledDowngrade, 'true');
  }

  if (flags.isHidePromoCodesEnabled) {
    searchParams.set(urlParamKeys.affHidePromoCodes, 'true');
  }

  if (flags.isAchMicroDepositsEnabled) {
    searchParams.set(urlParamKeys.affAchMicroDeposits, 'true');
  }

  return searchParams;
}
